import { motion } from 'framer-motion';
import { useState } from 'react';

const services = [
  {
    id: 1,
    title: "Digital Strategy",
    description: "Crafting bespoke digital solutions that elevate your brand",
    icon: "✦",
    gradient: "from-[#DBA858] via-[#E5C686] to-[#DBA858]"
  },
  {
    id: 2,
    title: "Brand Development",
    description: "Creating distinctive brand identities that leave lasting impressions",
    icon: "◈",
    gradient: "from-[#C8B6E2] via-[#DAC5F7] to-[#C8B6E2]"
  },
  {
    id: 3,
    title: "Web Experience",
    description: "Delivering immersive digital experiences that engage and inspire",
    icon: "❖",
    gradient: "from-[#89B9AD] via-[#9BCBBD] to-[#89B9AD]"
  }
];

const ServicesSection = () => {
  const [hoveredId, setHoveredId] = useState<number | null>(null);

  return (
    <section className="py-32 bg-[#0A0A0B]">
      <div className="max-w-6xl mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          className="text-center mb-20"
        >
          <h2 className="text-3xl font-light text-white tracking-[0.2em] uppercase mb-4">
            Our Expertise
          </h2>
          <div className="h-[1px] w-20 bg-gradient-to-r from-transparent via-[#DBA858] to-transparent mx-auto" />
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service) => (
            <motion.div
              key={service.id}
              onHoverStart={() => setHoveredId(service.id)}
              onHoverEnd={() => setHoveredId(null)}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              className="group relative"
            >
              <div className="relative overflow-hidden rounded-lg p-10 h-full
                            bg-[#111112] border border-white/5">
                <motion.div
                  className={`absolute inset-0 bg-gradient-to-br ${service.gradient} opacity-0 
                             group-hover:opacity-5 transition-opacity duration-500`}
                />
                
                <motion.div
                  animate={{
                    scale: hoveredId === service.id ? 1.2 : 1,
                    rotate: hoveredId === service.id ? 180 : 0
                  }}
                  className="text-4xl mb-8"
                  style={{ color: hoveredId === service.id ? '#DBA858' : '#ffffff' }}
                >
                  {service.icon}
                </motion.div>

                <h3 className="text-xl font-light text-white tracking-wider mb-4">
                  {service.title}
                </h3>
                
                <p className="text-gray-400 text-sm leading-relaxed mb-8">
                  {service.description}
                </p>

                <motion.button
                  className="text-sm text-white/60 hover:text-[#DBA858] 
                           tracking-wider uppercase flex items-center gap-2
                           transition-colors duration-300"
                >
                  Discover
                  <span className="text-xs">→</span>
                </motion.button>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection; 